import { dependency } from '../../utils/request';
import { directiveSettings } from '../../utils/parse';
import { frame, newElement } from '../../utils/drawing';
import { putData } from '../../utils/data';
/**
 * @module directives/media/swiper
 */

/**
 * The CDN directory of the Swiper library.
 *
 * @see http://idangero.us/swiper
 * @type {string}
 */
const swiperDirectory = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.3.8/';

/**
 * Initializes a Swiper carousel.
 * @see http://idangero.us/swiper
 */
let cssAdded = false;
export default function swiperDirective() {
  const swipers = document.querySelectorAll('[data-sw-swiper]');
	if (swipers.length > 0) {
		if (!cssAdded) {
      cssAdded = true;

      // Add style elements to head
      document.head.appendChild(newElement('link', {
        type: 'text/css',
        rel: 'stylesheet',
        href: `${swiperDirectory}css/swiper.min.css`
      }));
		};

            // Load in swiper lib and create swipers
		dependency(swiperDirectory + 'js/swiper.min.js', _ => window.Swiper !== null).then(_ => {
			swipers.forEach(element => {
        const data = element.getAttribute('data-sw-swiper'),
        settings = directiveSettings(data, {
          loop: true,
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
          },
          pagination: {
            type: 'button',
            clickable: true
          },
          runCallbacksOnInit: true,
          on: {
            slideChange: _ => { // call any global change functions
              if (Array.isArray(window.swiperChange)) window.swiperChange.map(f => f())
            }
          }
        });

                        // Add tp element to it so we can get the instance with getData()
				const slides = element.querySelectorAll('.swiper-slide');
        if (slides.length > 1)
          putData(element, 'swiperInstance', new Swiper(element, settings));
        
        // Call ready.
        frame(_ => element.classList.add('swiper-ready'));
			});
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/swiper.js